import type { FC } from "react";

import { UiWarningIcon } from "@jti/brand-icons/ui-warning";
import { useTranslations } from "@jti/ui";

import styles from "../../SecuredFieldsForm.module.scss";

type SecuredFieldsFieldErrorType = "invalid" | "missing";

type SecuredFieldsErrorMessageProps = {
  errorId: string;
  errorValue: SecuredFieldsFieldErrorType | undefined;
  translationKey: string;
};

export const SecuredFieldsErrorMessage: FC<SecuredFieldsErrorMessageProps> = ({
  errorId,
  errorValue,
  translationKey,
}) => {
  const { __ } = useTranslations();

  if (!errorValue) return null;

  const translationNamespace = errorValue === "missing" ? "field_missing" : "field_error";

  return (
    <div className={styles.errorRow} id={errorId} role="alert">
      <UiWarningIcon data-testid="errorIcon" className={styles.errorIcon} />
      <span className={styles.errorMessage}>
        {__(`cart.checkout.secured_fields.${translationNamespace}.${translationKey}`)}
      </span>
    </div>
  );
};
